import { computed } from 'vue';
import { applyPlatformCountryMessages } from '@/i18n';
import {
  PLATFORM_COUNTRIES,
  PLATFORM_COUNTRY_OPTIONS,
  activePlatformCountry,
  isPlatformCountry,
  persistActivePlatformCountry,
  platformCountryFlagClass,
  setActivePlatformCountry,
} from '@/platformCountry';

// Shared active-platform-country state and actions. Every place that shows or switches the platform
// the user is in (login page today; account switcher later) uses this and renders its own UI.
export function usePlatformCountry() {
  const currentPlatformCountry = computed(() => activePlatformCountry.value);
  const currentPlatformCountryLabel = computed(() => PLATFORM_COUNTRIES[activePlatformCountry.value].name);
  const currentFlagClass = computed(() => platformCountryFlagClass(activePlatformCountry.value));

  // Used for the login-page choice and for the signed-in account's platform. Always remembered,
  // so the next visit's login page opens on the last platform used.
  async function setPlatformCountry(platformCountry: unknown): Promise<void> {
    if (!isPlatformCountry(platformCountry)) return;
    const isChange = platformCountry !== activePlatformCountry.value;
    setActivePlatformCountry(platformCountry);
    persistActivePlatformCountry();
    if (isChange) await applyPlatformCountryMessages(platformCountry);
  }

  return {
    currentPlatformCountry,
    currentPlatformCountryLabel,
    currentFlagClass,
    platformCountryOptions: PLATFORM_COUNTRY_OPTIONS,
    setPlatformCountry,
  };
}
